import script from "./SelectUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectUser.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__